export const required = value => !!value || "Required"
export const min6 = value => /[a-zA-Z0-9]{6,}/.test(value) || "Min 6 latin characters"
export const validEmail = value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value) || "Invalid e-mail format"
}
